export default [
  {
    name: '초린이',
    image:
      'https://user-images.githubusercontent.com/81489300/174682203-92cd2e52-232f-442d-b2ea-3ca3beb88d09.png',
    description: '활동 점수 0 이상 30 미만',
    color: '#F2F9D7',
  },
  {
    name: '초록집사',
    image:
      'https://user-images.githubusercontent.com/81489300/174682206-33218082-6277-4bbb-96ad-ad699a950129.png',
    description: '활동 점수 30 이상 100 미만',
    color: '#D7EFCE',
  },
  {
    name: '초록현자',
    image:
      'https://user-images.githubusercontent.com/81489300/174682209-1bbee0de-c329-41b6-a9e5-ef62da5f850a.png',
    description: '활동 점수 100 이상 250 미만',
    color: '#FFDEC7',
  },
  {
    name: '식물마스터',
    image:
      'https://user-images.githubusercontent.com/81489300/174682210-94472dd4-1918-4e1c-9345-303b8202d4b9.png',
    description: '활동 점수 250 이상 500 미만',
    color: '#CEEDED',
  },
  {
    name: '태양신',
    image:
      'https://user-images.githubusercontent.com/81489300/174682212-41a1233f-0c3e-4bd4-bcc1-ad3e5109ee0e.png',
    description: '활동 점수 500 이상',
    color: '#FFF8D9',
  },
];
